// extracted by mini-css-extract-plugin
export default {"ReactionPicker":"styles_ReactionPicker__BpgNx","trigger":"styles_trigger__KRfeY","emojiList":"styles_emojiList__Yngva"};